import RegisterLogic from './RegisterLogic';
import UtilsIsLoggedIn from '../../utils/user/isLoggedIn';

export class RegisterOTP {
  constructor(props) {
   this.props = props;
  }

  async redirectAfterRegister(dataRegister) {
    this.registerLogic = new RegisterLogic(this.props); 
    this.registerLogic.successRegister(dataRegister);
    UtilsIsLoggedIn.setIntervalSuspendedAccount();
  }
}

export default RegisterOTP;




// WEBPACK FOOTER //
// ./src/authentication/Register/RegisterOTP.js